module.exports = __webpack_public_path__ + "static/package-2-bg-5ce8523c016bbf4dde8c9ea021c8bbfd.png";